import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface ImageUploadResponse {
  success: boolean;
  message: string;
  data: {
    relativePath: string;
    filePath: string;
    fileSize: number;
    fileType: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private uploadUrl = `${environment.uploadPath}`;

  constructor(private http: HttpClient) {

  }

  uploadImage(file: File): Observable<ImageUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ImageUploadResponse>(`${this.uploadUrl}/image-loader/upload`, formData);
  }

  getImageUrl(filePath: string): string {
    return `${this.uploadUrl}/image-loader/${filePath}`;
  }

  isImageFile(file: File): boolean {
    return !!file && file.type?.startsWith('image/');
  }
}


